import { Cookies, getCookie } from './cookies';

export function getUserProfileId(): string {
  return localStorage.getItem('guid') || '';
}

export function getAccountNumber(): string {
  return localStorage.getItem('accountNumber') || '';
}

export function isUserSignedIn(): boolean {
  return !!getCookie(Cookies.LOGGED_IN);
}
